(() => {
  if (customElements.get('mc-recommendation-slider')) return;
  customElements.define('mc-recommendation-slider', class extends HTMLElement {
    connectedCallback() {
      this.disconnectedCallback();
      this.slider = this.querySelector('[data-rp-slider]');
      this.progress = this.querySelector('[data-rp-progress]');
      if (!this.slider?.querySelector('.rp-card')) return;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.addEventListener('click', event => {
        if (event.target.closest('[data-rp-prev]')) this.slider.scrollBy({ left: -240, behavior: 'smooth' });
        if (event.target.closest('[data-rp-next]')) this.next();
        const dot = event.target.closest('.rp-progress-dot');
        if (dot) this.slider.scrollTo({ left: Number(dot.dataset.index) / Math.max(1, this.progress.children.length - 1) * (this.slider.scrollWidth - this.slider.clientWidth), behavior: 'smooth' });
      }, options);
      this.slider.addEventListener('keydown', event => {
        if (!['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
        event.preventDefault(); this.slider.scrollBy({ left: event.key === 'ArrowLeft' ? -240 : 240, behavior: 'smooth' });
      }, options);
      this.slider.addEventListener('scroll', () => this.updateProgress(), { ...options, passive: true });
      this.addEventListener('mouseenter', () => { this.hovered = true; this.plan(); }, options);
      this.addEventListener('mouseleave', () => { this.hovered = false; this.plan(); }, options);
      this.addEventListener('focusin', () => this.plan(), options);
      this.addEventListener('focusout', () => queueMicrotask(() => { if (this.isConnected) this.plan(); }), options);
      this.slider.addEventListener('touchstart', () => { this.touching = true; clearTimeout(this.touchTimer); this.plan(); }, { ...options, passive: true });
      this.slider.addEventListener('touchend', () => { this.touchTimer = setTimeout(() => { this.touching = false; this.plan(); }, 2000); }, { ...options, passive: true });
      this.slider.addEventListener('touchcancel', () => { this.touching = false; this.plan(); }, { ...options, passive: true });
      document.addEventListener('visibilitychange', () => this.plan(), options);
      this.visibility = new IntersectionObserver(entries => { this.visible = entries[0].isIntersecting; this.plan(); });
      this.visibility.observe(this);
      this.resize = new ResizeObserver(() => this.buildProgress()); this.resize.observe(this.slider);
      this.buildProgress();
    }
    disconnectedCallback() {
      this.abort?.abort(); this.visibility?.disconnect(); this.resize?.disconnect();
      clearInterval(this.timer); clearTimeout(this.touchTimer);
      this.timer = this.touchTimer = null; this.visible = this.hovered = this.touching = false;
    }
    buildProgress() {
      if (!this.isConnected) return;
      const count = Math.min(6, Math.ceil(this.slider.querySelectorAll('.rp-card').length / Math.max(1, Math.floor(this.slider.offsetWidth / 200))));
      if (this.progress.children.length !== count) {
        this.progress.replaceChildren(...Array.from({ length: count }, (_, index) => {
          const dot = document.createElement('div'); dot.className = 'rp-progress-dot'; dot.dataset.index = index;
          dot.setAttribute('aria-label', this.dataset.pageLabel + ' ' + (index + 1)); return dot;
        }));
      }
      this.updateProgress();
    }
    updateProgress() {
      const max = this.slider.scrollWidth - this.slider.clientWidth;
      const active = Math.round((max > 0 ? this.slider.scrollLeft / max : 0) * (this.progress.children.length - 1));
      [...this.progress.children].forEach((dot, index) => { dot.classList.toggle('is-active', index === active); dot.setAttribute('aria-current', index === active ? 'true' : 'false'); });
    }
    next() {
      if (this.slider.scrollLeft >= this.slider.scrollWidth - this.slider.clientWidth - 10) this.slider.scrollTo({ left: 0, behavior: 'smooth' });
      else this.slider.scrollBy({ left: 240, behavior: 'smooth' });
    }
    plan() {
      clearInterval(this.timer); this.timer = null;
      if (this.isConnected && this.visible && !document.hidden && !this.hovered && !this.touching && !this.contains(document.activeElement) && !matchMedia('(prefers-reduced-motion: reduce)').matches) this.timer = setInterval(() => this.next(), 3000);
    }
  });
})();
